<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <b>Descrição</b>
          <textarea
            v-model="data.description"
            :disabled="!canAccess()"
            class="form-control description"
            maxlength="580"
          ></textarea>
        </div>
      </div>
      <div class="d-flex imagesRisk justify-content-end w-100 flex-wrap">
        <div class="row w-100" v-show="renderImg">
          <div
            class="col-6"
            v-for="(photo, index) in data.photos"
            v-bind:key="index"
            v-show="renderPhoto"
          >
            <div
              style="height: 50vh"
              class="imgDeletable form-group card-photo d-flex justify-content-center"
            >
              <div class="deleteIcon" v-on:click="deleteImage(index)" v-if="canAccess()">
                <font-awesome-icon icon="times" />
              </div>
              <img
                :src="photo.url ? photo.url : photo"
                alt
                style="width: 100% !important; height: auto; margin-top: 20px"
                class="image image-rounded"
              />
            </div>
          </div>
        </div>
        <button
          class="col-6 btn btn-primary w-100"
          v-if="(data.photos.length == 0 || (data.photos[0] && !data.photos[1])) && canAccess()"
          v-on:click="openModal('photo-modal')"
          >Nova Foto
          </button>
      </div>
    </div>
    <b-modal
      ref="photo-modal"
      size="xl"
      title="Adicionar Imagem"
      @ok="saveImage()"
    >
      <ImageEditor
        ref="imageEditor"
        :selected-directory="'Fotos'"
        :machine_id="machine_id"
      ></ImageEditor>
      <template v-slot:modal-cancel>Cancelar</template>
      <template v-slot:modal-ok>Salvar</template>
    </b-modal>
    <hr v-if="extras == 'true'"/>
    <div class="row" v-if="extras == 'true'">
      <div class="col-12">
        <div class="titleAPR" style="background-color: #feffcc">
          Apreciação do risco antes das ações de melhoria
        </div>
      </div>
      <div class="col-2">
        <div class="form-group aprForm">
          <label class="textGray">NP</label>
          <select
            class="form-control smallInput"
            v-model="data.natural_score_np"
            v-on:change="calculateHRNnatural()"
            :disabled="!canAccess()"
          >
            <option value disabled>Selecione uma opção</option>
            <option
              v-for="np_value in np_values"
              :key="np_value"
              :value="np_value"
            >
              {{ np_value }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-2">
        <div class="form-group aprForm">
          <label class="textGray">DPH</label>
          <select
            class="form-control smallInput"
            v-model="data.natural_score_dph"
            v-on:change="calculateHRNnatural()"
            :disabled="!canAccess()"
          >
            <option value disabled>Selecione uma opção</option>
            <option
              v-for="dph_value in dph_values"
              :key="dph_value"
              :value="dph_value"
            >
              {{ dph_value }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-2">
        <div class="form-group aprForm">
          <label class="textGray">FE</label>
          <select
            class="form-control smallInput"
            v-model="data.natural_score_fe"
            v-on:change="calculateHRNnatural()"
            :disabled="!canAccess()"
          >
            <option value disabled>Selecione uma opção</option>
            <option
              v-for="fe_value in fe_values"
              :key="fe_value"
              :value="fe_value"
            >
              {{ fe_value }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-2">
        <div class="form-group aprForm">
          <label class="textGray">LO</label>
          <select
            class="form-control smallInput"
            v-model="data.natural_score_lo"
            v-on:change="calculateHRNnatural()"
            :disabled="!canAccess()"
          >
            <option value disabled>Selecione uma opção</option>
            <option
              v-for="lo_value in lo_values"
              :key="lo_value"
              :value="lo_value"
            >
              {{ lo_value }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-2">
        <div class="form-group aprForm">
          <label class="textGray">HRN</label>
          <input
            v-model="data.natural_score_hrn"
            type="number"
            class="form-control smallInput"
            disabled
          />
        </div>
      </div>
      <div class="col-2">
        <div class="form-group aprForm">
          <label class="textGray">Classe de Risco</label>
          <input
            v-if="render"
            v-model="data.natural_hazard_class"
            type="text"
            class="form-control smallInput"
            disabled
          />
        </div>
      </div>
      <div
        class="col-12 mt-4"
        style="text-align: center"
        v-if="
          data.sif_result_natural != '' && data.sif_result_natural != undefined
        "
      >
        <span class="result">
          SIF RA:
          <strong>{{ data.sif_result_natural }}</strong>
        </span>
      </div>
    </div>

    <hr />
    <div class="row">
      <div class="col-12">
        <div class="titleAPR" style="background-color: #eeece1">
          Apreciação do risco atual
        </div>
      </div>
      <div class="col-2">
        <div class="form-group aprForm">
          <label class="textGray">NP</label>
          <select
            class="form-control smallInput"
            v-model="data.score_np"
            v-on:change="calculateHRNbefore()"
            :disabled="!canAccess()"
          >
            <option value disabled>Selecione uma opção</option>
            <option
              v-for="np_value in np_values"
              :key="np_value"
              :value="np_value"
            >
              {{ np_value }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-2">
        <div class="form-group aprForm">
          <label class="textGray">DPH</label>
          <select
            class="form-control smallInput"
            v-model="data.score_dph"
            v-on:change="calculateHRNbefore()"
            :disabled="!canAccess()"
          >
            <option value disabled>Selecione uma opção</option>
            <option
              v-for="dph_value in dph_values"
              :key="dph_value"
              :value="dph_value"
            >
              {{ dph_value }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-2">
        <div class="form-group aprForm">
          <label class="textGray">FE</label>
          <select
            class="form-control smallInput"
            v-model="data.score_fe"
            v-on:change="calculateHRNbefore()"
            :disabled="!canAccess()"
          >
            <option value disabled>Selecione uma opção</option>
            <option
              v-for="fe_value in fe_values"
              :key="fe_value"
              :value="fe_value"
            >
              {{ fe_value }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-2">
        <div class="form-group aprForm">
          <label class="textGray">LO</label>
          <select
            class="form-control smallInput"
            v-model="data.score_lo"
            v-on:change="calculateHRNbefore()"
            :disabled="!canAccess()"
          >
            <option value disabled>Selecione uma opção</option>
            <option
              v-for="lo_value in lo_values"
              :key="lo_value"
              :value="lo_value"
            >
              {{ lo_value }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-2">
        <div class="form-group aprForm">
          <label class="textGray">HRN</label>
          <input
            v-model="data.score_hrn"
            type="number"
            class="form-control smallInput"
            disabled
          />
        </div>
      </div>
      <div class="col-2">
        <div class="form-group aprForm">
          <label class="textGray">Classe de Risco</label>
          <input
            v-model="data.score_hazard_class"
            type="text"
            class="form-control smallInput"
            disabled
          />
        </div>
      </div>
      <div
        class="col-12 mt-4"
        style="text-align: center"
        v-if="
          extras == 'true' &&
          data.sif_result_before != '' &&
          data.sif_result_before != undefined
        "
      >
        <span class="result">
          SIF RA:
          <strong>{{ data.sif_result }}</strong>
        </span>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-12">
        <div class="titleAPR" style="background-color: #d6e3bc">
          Apreciação do risco após as ações de melhoria
        </div>
      </div>
      <div class="col-2">
        <div class="form-group aprForm">
          <label class="textGray">NP</label>
          <select
            class="form-control smallInput"
            v-model="data.improvement_score_np"
            v-on:change="calculateHRNafter()"
            :disabled="!canAccess()"
          >
            <option value disabled>Selecione uma opção</option>
            <option
              v-for="np_value in np_values"
              :key="np_value"
              :value="np_value"
            >
              {{ np_value }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-2">
        <div class="form-group aprForm">
          <label class="textGray">DPH</label>
          <select
            class="form-control smallInput"
            v-model="data.improvement_score_dph"
            v-on:change="calculateHRNafter()"
            :disabled="!canAccess()"
          >
            <option value disabled>Selecione uma opção</option>
            <option
              v-for="dph_value in dph_values"
              :key="dph_value"
              :value="dph_value"
            >
              {{ dph_value }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-2">
        <div class="form-group aprForm">
          <label class="textGray">FE</label>
          <select
            class="form-control smallInput"
            v-model="data.improvement_score_fe"
            v-on:change="calculateHRNafter()"
            :disabled="!canAccess()"
          >
            <option value disabled>Selecione uma opção</option>
            <option
              v-for="fe_value in fe_values"
              :key="fe_value"
              :value="fe_value"
            >
              {{ fe_value }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-2">
        <div class="form-group aprForm">
          <label class="textGray">LO</label>
          <select
            class="form-control smallInput"
            v-model="data.improvement_score_lo"
            v-on:change="calculateHRNafter()"
            :disabled="!canAccess()"
          >
            <option value disabled>Selecione uma opção</option>
            <option
              v-for="lo_value in lo_values"
              :key="lo_value"
              :value="lo_value"
            >
              {{ lo_value }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-2">
        <div class="form-group aprForm">
          <label class="textGray">HRN</label>
          <input
            v-model="data.improvement_score_hrn"
            type="number"
            class="form-control smallInput"
            disabled
          />
        </div>
      </div>
      <div class="col-2">
        <div class="form-group aprForm">
          <label class="textGray">Classe de Risco</label>
          <input
            v-if="render"
            v-model="data.improvement_hazard_class"
            type="text"
            class="form-control smallInput"
            disabled
          />
        </div>
      </div>
      <div
        class="col-12 mt-4"
        style="text-align: center"
        v-if="
          extras == 'true' &&
          data.sif_result_after != '' &&
          data.sif_result_after != undefined
        "
      >
        <span class="result">
          SIF RA:
          <strong>{{ data.sif_result_improvement }}</strong>
        </span>
      </div>
    </div>
    <hr />
    <div class="improvementActionsContent">
      <div class="titleAPR mb-3">
        Ações de Melhoria <span class="error">*</span>
      </div>
      <div v-if="renderImprovementAction" class="w-100 mb-3">
        <div
          v-for="(improvement_action, index) in data.improvement_actions"
          v-bind:key="index"
          class="col-12 risk"
        >
          <Accordion>
            <template v-slot:title>
              <span style="font-size: 18px">{{ improvement_action.name }}</span>
            </template>
            <template v-slot:body>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <div class="titleAPR">
                      <label for>
                        Ação de melhoria
                        <span class="error">*</span>
                      </label>
                    </div>
                    <textarea
                      v-model="improvement_action.description"
                      class="form-control description"
                      :disabled="!canAccess()"
                    ></textarea>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <div class="titleAPR">
                      <label for> Número de referência </label>
                    </div>
                    <input
                      v-model="improvement_action.ref_number"
                      class="form-control"
                      :disabled="!canAccess()"
                    />
                    <!-- <multiselect
                      v-if="renderRefNumber"
                      v-model="improvement_action.ref_number"
                      @input="reloadRefNumbers"
                      :multiple="false"
                      :options="references"
                      track-by="id"
                      label="code"
                      placeholder="Selecione normativas"
                    ></multiselect> -->
                  </div>
                </div>
                <div class="col-6">
                  <!-- <button
                    class="btn btn-secondary smallBtn"
                    v-if="canAccess()"
                  >Copiar ações de outra máquina</button>-->
                  <!-- <button class="btn btn-secondary smallBtn" style="margin-left:8px">
          <font-awesome-icon icon="headphones" />Ouvir nota em áudio
                  </button>-->
                </div>
                <div class="col-6" style="display: flex; align-items: center">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="improvement_action.include_to_action_plan"
                      id="checkIncludeActionPlan"
                      :disabled="!canAccess()"
                    />
                    <label class="form-check-label" for="checkIncludeActionPlan"
                      >Incluir ação de melhoria no plano de ação</label
                    >
                  </div>
                </div>
                <div class="col-12">
                  <button
                    class="btn btn-danger"
                    type="button"
                    v-on:click="openModalActionToDelete(improvement_action)"
                    v-if="
                      canAccess() && data.improvement_actions.length == index + 1
                    "
                  >
                    <font-awesome-icon icon="trash" /> Excluir Ação
                  </button>
                </div>
              </div>
            </template>
          </Accordion>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <button
            class="btn btn-primary float-right"
            v-if="canAccess()"
            v-on:click="newImprovementAction()"
          >
            <span
              >Adicionar Ação de Melhoria <font-awesome-icon icon="plus" />
            </span>
          </button>
        </div>
      </div>
    </div>

    <hr />
    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <div class="titleAPR">
            <label for>Categoria</label>
          </div>
          <input
            type="text"
            v-model="data.category"
            class="form-control"
            :disabled="!canAccess()"
          />
        </div>
      </div>
      <!-- <input v-on:change="uploadImage" type="file" name="photo" accept="image/*" />
      <img :src="imageSrc" class="image" />-->
      <div class="col-12">
        <button
          class="btn btn-success float-right"
          v-on:click="save()"
          :disabled="saving"
          v-if="!readonly"
        >
          <span>Salvar Risco <font-awesome-icon icon="save" /> </span>
        </button>
        <b-spinner label="Small Spinner" v-if="saving"></b-spinner>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-padding">
        <b-alert v-show="alert" :variant="alert_type" show>{{
          alert_msg
        }}</b-alert>
      </div>
    </div>

    <b-modal
      ref="hazard-descriptions-modal"
      title="Copiar descrição"
      class="copy"
      @ok="copyDescriptions()"
    >
      <div
        v-for="(hazard, index) in hazardDescriptions"
        v-bind:key="hazard.id"
        class="col-12 col-padding"
      >
        <div class="description-item col-12">
          <label
            :for="'description-' + index"
            class="col-12 checkbox-container"
          >
            <input
              :id="'description-' + index"
              v-model="selectedDescriptions"
              :value="hazard.description"
              type="checkbox"
            />
            <span class="checkmark"></span>
            <div class="header">
              Máquina: {{ hazard.machine }}
              <br />
              Risco: {{ hazard.name ? hazard.name : "Nome indefinido" }}
            </div>
            <div class="body col-12 description-item-text">
              Descrição: {{ hazard.description }}
            </div>
          </label>
        </div>
      </div>
      <template v-slot:modal-cancel>Cancelar</template>
      <template v-slot:modal-ok>Copiar</template>
    </b-modal>
    <b-modal
      ref="action-confirm-modal"
      title="Remover Ação"
      modal-ok="Confirmar"
      modal-cancel="Cancelar"
      @ok="removeImprovementAction()"
    >
      Deseja mesmo remover a ação de melhoria:
      {{ actionToDelete ? actionToDelete.name : "" }}
      <template v-slot:modal-cancel>Cancelar</template>
      <template v-slot:modal-ok>Confirmar</template>
    </b-modal>
  </div>
</template>
<script>
import axios from "@/api/axios";
import Accordion from "@/components/Accordion.vue";
import ImageEditor from "@/components/ImageEditor.vue";
import { canAccess } from "@/utils/canAccess";
import Vue from "vue";
import { required } from "vuelidate/lib/validators";

export default {
  name: "hazard",
  data() {
    return {
      tempImage: "",
      saving: false,
      imageSrc: "",
      renderImg: true,
      renderPhoto: true,
      render: true,
      selectedDescriptions: [],
      alert: false,
      alert_type: "success",
      alert_msg: "Item salvo com sucesso",
      renderCanvas: true,
      np_values: [1, 2, 4, 8, 12],
      fe_values: [0.1, 0.5, 1, 1.5, 2.5, 4, 5],
      dph_values: [0.1, 0.5, 1, 2, 4, 8, 10, 12, 15],
      lo_values: [0.033, 0.1, 0.5, 1, 1.5, 2, 3.5, 5, 10, 15],
      renderImprovementAction: false,
      references: [],
      renderRefNumber: true,
      actionToDelete: null,
    };
  },
  components: {
    Accordion,
    ImageEditor,
  },
  props: {
    hazard_analysis_id: String,
    data: Object,
    hazardDescriptions: Array,
    readonly: {
      type: Boolean,
      default: false,
    },
    hazardIndex: Number,
    machine_id: {
      type: String,
      required: true,
    },
    extras: {
      type: String,
      default: () => localStorage.getItem('extras') || 'false',
    },
  },
  watch: {
    'data.name': function(newName, oldName) {
      if (newName !== oldName && oldName) {
        this.syncActionNames();
      }
    },
    'hazardIndex': function(newIndex, oldIndex) {
      if (newIndex !== oldIndex && oldIndex !== undefined) {
        this.reorderActions();
      }
    },
    // A APR troca os objetos dos riscos (getAPR) e o Vue reaproveita este componente (key = índice):
    // o mounted() não roda de novo, então os campos derivados precisam ser reinicializados aqui.
    data(novo, antigo) {
      if (novo !== antigo) {
        this.inicializarCampos();
      }
    },
  },
  mounted() {
    this.inicializarCampos();
  },
  validations: {
    data: {
      score_np: { required },
      score_dph: { required },
      score_fe: { required },
      score_lo: { required },
      number_code: { required },
      hazard_analysis_id: { required },
      action_plan: { required },
    },
  },
  methods: {
    canAccess,
    /**
     * Prepara os campos que a tela usa e que a API não devolve (HRN, classe e SIF de cada seção).
     *
     * Usa $set para os campos nascerem reativos: com atribuição simples eles ficam fora do sistema de
     * reatividade e o Vue.set dos métodos de cálculo deixa de notificar a tela.
     *
     * Pode rodar mais de uma vez no mesmo objeto (o componente é reaproveitado quando o risco muda de
     * posição na lista). Por isso o que já existe, incluindo o HRN calculado na tela, não é sobrescrito.
     */
    inicializarCampos: function () {
      const risco = this.data;
      const definir = (chave, valor) => this.$set(risco, chave, valor);
      const definirSeAusente = (chave, valor) => {
        if (!(chave in risco)) {
          definir(chave, valor);
        }
      };

      ["score_", "improvement_score_"].forEach((prefixo) =>
        ["np", "dph", "fe", "lo"].forEach((fator) =>
          definir(prefixo + fator, risco[prefixo + fator] ? risco[prefixo + fator] : 0)
        )
      );

      // Risco novo (APR.addHazard) nasce sem hrn e sem sif: não há o que inicializar.
      if (!risco.hrn || !risco.sif) {
        return;
      }
      // ATUAL
      definirSeAusente("score_hrn", risco.hrn.hrn ? risco.hrn.hrn : 0);
      definirSeAusente("score_hazard_class", risco.hrn.hrn_level ? risco.hrn.hrn_level : "Aceitável");
      definirSeAusente("sif_result", risco.sif.sif_result ? risco.sif.sif_result : 0);
      // IMPROVEMENT
      definirSeAusente("improvement_score_hrn", risco.hrn.hrn_improvement ? risco.hrn.hrn_improvement : 0);
      definirSeAusente(
        "improvement_hazard_class",
        risco.hrn.hrn_improvement_level ? risco.hrn.hrn_improvement_level : "Aceitável"
      );
      definirSeAusente(
        "sif_result_improvement",
        risco.sif.sif_result_improvement ? risco.sif.sif_result_improvement : 0
      );
      // NATURAL
      definirSeAusente("natural_score_hrn", risco.hrn.hrn_natural ? risco.hrn.hrn_natural : 0);
      definirSeAusente(
        "natural_hazard_class",
        risco.hrn.hrn_natural_level ? risco.hrn.hrn_natural_level : "Aceitável"
      );
      definirSeAusente("sif_result_natural", risco.sif.sif_result_natural ? risco.sif.sif_result_natural : 0);

      this.renderImprovementAction = true;
    },
    reorderImprovementActions: function() {
      if (!this.data.improvement_actions || this.data.improvement_actions.length === 0) {
        return;
      }
      
      this.data.improvement_actions.forEach((action, index) => {
        const newName = `${this.data.name}.${index + 1}`;
        if (action.name !== newName) {
          action.name = newName;
        }
      });
      
      this.renderImprovementAction = false;
      this.$nextTick(() => {
        this.renderImprovementAction = true;
      });
    },
    
    syncActionNames: function() {
      if (this.data.improvement_actions && this.data.improvement_actions.length > 0) {
        this.reorderImprovementActions();
      }
    },

    reorderActions: function() {
      this.reorderImprovementActions();
    },

    newImprovementAction: function () {
      this.$emit("pushHazard", this.data.name);
      this.renderImprovementAction = false;
      
      if (!this.data.improvement_actions) {
        this.data.improvement_actions = [];
      }
      
      const newActionName = `${this.data.name}.${this.data.improvement_actions.length + 1}`;
      
      this.data.improvement_actions.push({
        name: newActionName,
        description: '',
        ref_number: '',
        include_to_action_plan: false
      });
      
      this.renderImprovementAction = true;
    },
    calculateSIFResult: function (np, dph, fe, lo) {
      let promise = axios.post(
        `${process.env.VUE_APP_API_HOST}/api/admin/calculate-sif`,
        {
          np: np,
          dph: dph,
          fe: fe,
          lo: lo,
        }
      );
      return promise;
    },
    calculateHRN: function (np, dph, fe, lo) {
      let promise = axios.post(
        `${process.env.VUE_APP_API_HOST}/api/admin/calculate-hrn`,
        {
          np: np,
          dph: dph,
          fe: fe,
          lo: lo,
        }
      );
      return promise;
    },
    /**
     * O cálculo falhou (rede, 429 do throttle, erro da API): o valor que está na tela é o da nota
     * anterior, então a pessoa precisa saber que ele não corresponde às notas atuais.
     */
    avisarFalhaCalculo: function (calculo) {
      this.alert_type = "warning";
      this.alert_msg = `Não foi possível calcular o ${calculo}. Confira as notas e tente novamente.`;
      this.alert = true;
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    calculateHRNafter: function () {
      if (this.extras == "true") {
        this.calculateSIFResult(
          this.data.improvement_score_np,
          this.data.improvement_score_dph,
          this.data.improvement_score_fe,
          this.data.improvement_score_lo
        ).then((response) => {
          this.render = false;
          const vm = this;
          Vue.nextTick(function () {
            Vue.set(vm.data, "sif_result_improvement", response.data.sif_result);
            vm.render = true;
          });
        }).catch(() => this.avisarFalhaCalculo("SIF"));
      }

      this.calculateHRN(
        this.data.improvement_score_np,
        this.data.improvement_score_dph,
        this.data.improvement_score_fe,
        this.data.improvement_score_lo
      ).then((response) => {
        this.render = false;
        const vm = this;
        Vue.nextTick(function () {
          Vue.set(vm.data, "improvement_score_hrn", response.data.hrn);
          Vue.set(vm.data, "improvement_hazard_class", response.data.hrnLevel);
          vm.render = true;
        });
      }).catch(() => this.avisarFalhaCalculo("HRN"));
    },
    calculateHRNnatural: function () {
      if (this.extras == "true") {
        this.calculateSIFResult(
          this.data.natural_score_np,
          this.data.natural_score_dph,
          this.data.natural_score_fe,
          this.data.natural_score_lo
        ).then((response) => {
          this.render = false;
          const vm = this;
          Vue.nextTick(function () {
            Vue.set(vm.data, "sif_result_natural", response.data.sif_result);
            vm.render = true;
          });
        }).catch(() => this.avisarFalhaCalculo("SIF"));
      }
      this.calculateHRN(
        this.data.natural_score_np,
        this.data.natural_score_dph,
        this.data.natural_score_fe,
        this.data.natural_score_lo
      ).then((response) => {
        this.render = false;
        const vm = this;
        Vue.nextTick(function () {
          Vue.set(vm.data, "natural_score_hrn", response.data.hrn);
          Vue.set(vm.data, "natural_hazard_class", response.data.hrnLevel);
          vm.render = true;
        });
      }).catch(() => this.avisarFalhaCalculo("HRN"));
    },
    calculateHRNbefore: function () {
      if (this.extras == "true") {
        this.calculateSIFResult(
          this.data.score_np,
          this.data.score_dph,
          this.data.score_fe,
          this.data.score_lo
        ).then((response) => {
          this.render = false;
          const vm = this;
          Vue.nextTick(function () {
            Vue.set(vm.data, "sif_result", response.data.sif_result);
            vm.render = true;
          });
        }).catch(() => this.avisarFalhaCalculo("SIF"));
      }
      this.calculateHRN(
        this.data.score_np,
        this.data.score_dph,
        this.data.score_fe,
        this.data.score_lo
      ).then((response) => {
        this.render = false;
        const vm = this;
        Vue.nextTick(function () {
          Vue.set(vm.data, "score_hrn", response.data.hrn);
          Vue.set(vm.data, "score_hazard_class", response.data.hrnLevel);
          vm.render = true;
        });
      }).catch(() => this.avisarFalhaCalculo("HRN"));
    },
    copyDescriptions: function () {
      this.data.description = this.selectedDescriptions
        .join("\n")
        .substr(0, 1000);
    },
    cleanDuplicateActions: function () {
      if (!this.data.improvement_actions) return;
      
      const seen = new Set();
      const uniqueActions = [];
      
      this.data.improvement_actions.forEach(action => {
        if (!seen.has(action.name)) {
          seen.add(action.name);
          uniqueActions.push(action);
        }
      });
      
      this.data.improvement_actions = uniqueActions;
    },
    async saveImprovementActions() {
      this.cleanDuplicateActions();

      if (!this.data.improvement_actions || this.data.improvement_actions.length === 0) {
        return;
      }

      for (let index = 0; index < this.data.improvement_actions.length; index++) {
        const improvement_action = this.data.improvement_actions[index];

        if (improvement_action.id) {
          await this.updateImprovementAction(improvement_action, index);
        } else {
          try {
            const response = await axios.post(
              `${process.env.VUE_APP_API_HOST}/api/admin/improvement-actions`,
              {
                name: improvement_action.name,
                description: improvement_action.description,
                ref_number: improvement_action.ref_number,
                include_to_action_plan: improvement_action.include_to_action_plan,
                hazard_id: this.data.id,
              }
            );

            this.data.improvement_actions[index] = response.data;
          } catch (err) {
            this.alert_type = "warning";
            this.alert_msg = `Erro ao salvar ação ${improvement_action.name}`;
            this.alert = true;
          }
        }
      }
    },
    updateImprovementAction: function (improvement_action, index) {
      axios
        .put(
          `${process.env.VUE_APP_API_HOST}/api/admin/improvement-actions/${improvement_action.id}`,
          {
            name: improvement_action.name,
            description: improvement_action.description,
            ref_number: improvement_action.ref_number,
            include_to_action_plan: improvement_action.include_to_action_plan,
          }
        )
        .then((response) => {
          this.data.improvement_actions[index] = response.data;
        })
        .catch(() => {
          this.alert_type = "warning";
          this.alert_msg = `Erro ao atualizar ação ${improvement_action.name}`;
          this.alert = true;
        });
    },
    save: function () {
      if(!this.data.improvement_actions || this.data.improvement_actions.length === 0) {
        this.alert_type = "warning";
        this.alert_msg = "Adicione ao menos uma ação de melhoria";
        this.alert = true;
        const vm = this;
        setTimeout(() => {
          vm.alert = false;
        }, 3000);
        return;
      }
      var tmp = false;

      if (this.extras == "true") {
        if (
          this.data.natural_score_np == "" ||
          this.data.natural_score_np == undefined ||
          this.data.natural_score_dph == "" ||
          this.data.natural_score_dph == undefined ||
          this.data.natural_score_fe == "" ||
          this.data.natural_score_fe == undefined ||
          this.data.natural_score_lo == "" ||
          this.data.natural_score_lo == undefined
        ) {
          tmp = true;
        }
      }
      if (
        this.data.name == undefined ||
        this.data.name == "" ||
        this.data.description == "" ||
        this.data.description == undefined ||
        this.data.score_np == "" ||
        this.data.score_np == undefined ||
        this.data.score_dph == "" ||
        this.data.score_dph == undefined ||
        this.data.score_fe == "" ||
        this.data.score_fe == undefined ||
        this.data.score_lo == "" ||
        this.data.score_lo == undefined ||
        this.data.improvement_score_np == "" ||
        this.data.improvement_score_np == undefined ||
        this.data.improvement_score_dph == "" ||
        this.data.improvement_score_dph == undefined ||
        this.data.improvement_score_fe == "" ||
        this.data.improvement_score_fe == undefined ||
        this.data.improvement_score_lo == "" ||
        this.data.improvement_score_lo == undefined ||
        this.data.category == "" ||
        this.data.category == undefined ||
        tmp
      ) {
        this.alert_type = "warning";
        this.alert_msg = "Preencha todos os campos";
        this.alert = true;
        const vm = this;
        setTimeout(() => {
          vm.alert = false;
        }, 3000);
      } else {
        if (this.data.id) {
          this.update();
          return true;
        }
        this.saving = true;
        let imagesClean = [];
        if (this.data.images) {
          for (let i = 0; i < this.data.images.length; i++) {
            let x = this.data.images[i].split(",");
            imagesClean.push(x[1]);
          }
        }
        axios
          .post(`${process.env.VUE_APP_API_HOST}/api/admin/hazards`, {
            name: this.data.name,
            description: this.data.description,
            score_np: this.data.score_np,
            score_dph: this.data.score_dph,
            score_fe: this.data.score_fe,
            score_lo: this.data.score_lo,
            improvement_score_np: this.data.improvement_score_np,
            improvement_score_dph: this.data.improvement_score_dph,
            improvement_score_fe: this.data.improvement_score_fe,
            improvement_score_lo: this.data.improvement_score_lo,
            natural_score_np: this.data.natural_score_np,
            natural_score_dph: this.data.natural_score_dph,
            natural_score_fe: this.data.natural_score_fe,
            natural_score_lo: this.data.natural_score_lo,
            hazard_analysis_id: this.hazard_analysis_id,
            category: this.data.category,
            action_plan: this.data.action_plan,
            images: imagesClean,
            sif_result_after: this.data.sif_result_after,
            sif_result_before: this.data.sif_result_before,
            sif_result_natural: this.data.sif_result_natural,
          })
          .then((response) => {
            this.saving = false;
            if (response.data.id) {
              this.$emit("save", this.data.name);
              this.data.id = response.data.id;
              this.data.name = response.data.name;
              this.saveImprovementActions();
              // this.data = response.data;
              this.alert_type = "success";
              this.alert_msg = "Risco salvo com sucesso";
              this.alert = true;
              const vm = this;
              setTimeout(() => {
                vm.alert = false;
              }, 3000);
            } else {
              this.alert_type = "warning";
              this.alert_msg = "Ocorreu um erro";
              this.alert = true;
              const vm = this;
              setTimeout(() => {
                vm.alert = false;
              }, 3000);
            }
          })
          .catch(() => {
            this.alert_type = "warning";
            this.alert_msg = "Ocorreu um erro";
            this.alert = true;
            const vm = this;
            setTimeout(() => {
              vm.alert = false;
            }, 3000);
          });
      }
    },
    update: function () {
      let imagesClean = [];
      if (this.data.photos) {
        for (let i = 0; i < this.data.photos.length; i++) {
          if (!this.data.photos[i].id) {
            let x = this.data.photos[i].split(",");
            imagesClean.push(x[1]);
          }
        }
      }
      axios
        .put(
          `${process.env.VUE_APP_API_HOST}/api/admin/hazards/` + this.data.id,
          {
            name: this.data.name,
            description: this.data.description,
            score_np: this.data.score_np,
            score_dph: this.data.score_dph,
            score_fe: this.data.score_fe,
            score_lo: this.data.score_lo,
            improvement_score_np: this.data.improvement_score_np,
            improvement_score_dph: this.data.improvement_score_dph,
            improvement_score_fe: this.data.improvement_score_fe,
            improvement_score_lo: this.data.improvement_score_lo,
            natural_score_np: this.data.natural_score_np,
            natural_score_dph: this.data.natural_score_dph,
            natural_score_fe: this.data.natural_score_fe,
            natural_score_lo: this.data.natural_score_lo,
            hazard_analysis_id: this.hazard_analysis_id,
            category: this.data.category,
            action_plan: this.data.action_plan,
            photos: this.data.photos,
            images: imagesClean,
            user_id: localStorage.getItem("auth.user_id"),
            include_to_action_plan: this.data.include_to_action_plan,
            ref_number: this.data.ref_number,
            sif_result_after: this.data.sif_result_after,
            sif_result_before: this.data.sif_result_before,
            sif_result_natural: this.data.sif_result_natural,
          }
        )
        .then((response) => {
          this.saving = false;
          if (response.data.id) {
            this.$emit("save", this.data.name);
            this.data.id = response.data.id;
            this.saveImprovementActions();
            this.alert_type = "success";
            this.alert_msg = "Item atualizado com sucesso";
            this.alert = true;
            const vm = this;
            setTimeout(() => {
              const activeAccordion = document.querySelector(
                ".accordion.active .header"
              );
              if (activeAccordion) {
                activeAccordion.click(); // Trigger the click event
              }

              const accordion = document.querySelector(".accordion.active");
              if (accordion) {
                accordion.classList.remove("active");
              }
              vm.alert = false;
            }, 3000);
          } else {
            this.alert_type = "warning";
            this.alert_msg = "Ocorreu um erro";
            this.alert = true;
            const vm = this;
            setTimeout(() => {
              vm.alert = false;
            }, 3000);
          }
        })
        .catch(() => {
          this.alert_type = "warning";
          this.alert_msg = "Ocorreu um erro";
          this.alert = true;
          const vm = this;
          setTimeout(() => {
            vm.alert = false;
          }, 3010);
        });
    },
    saveImage: function () {
      this.renderPhoto = false;
      this.renderImg = false;
      this.tempImage = this.$refs.imageEditor.getImageEdit();
      if (!this.data.photos) {
        this.data.photos = [];
      }
      if (this.tempImage) {
        this.data.photos.push(this.tempImage);
        Vue.set(this.data, "photos", this.data.photos);
        this.tempImage = "";
        const vm = this;
        Vue.nextTick(function () {
          Vue.set(vm.data, "images", vm.data.photos);
        });
      }
      this.renderPhoto = true;
      this.renderImg = true;
    },
    uploadImage: function (e) {
      const file = e.target.files[0];
      if (!file.type.includes("image/")) {
        return;
      }

      if (typeof FileReader === "function") {
        const reader = new FileReader();

        reader.onload = (event) => {
          this.tempImage = event.target.result;
          this.$refs.editor.setBackgroundImage(this.tempImage);
          // let textModeOptions = {
          //   fill: "red",
          //   fontFamily: "Verdana",
          //   fontSize: 16,
          //   placeholder: "Type something"
          // };
          this.$refs.editor.set("circle");
        };
        reader.readAsDataURL(file);
      }
    },
    openModal: function (modal) {
      this.$refs[modal].show();
    },
    deleteImage: function (position) {
      const vm = this;
      this.renderImg = false;
      Vue.nextTick(function () {
        vm.data.photos.splice(position, 1);
        vm.renderImg = true;
      });
    },
    showError: function (attribute) {
      return this.$v.hazard[attribute].$invalid && this.submited;
    },
    required: function (attribute) {
      return this.$v.hazard[attribute].$params.required;
    },
    openModalActionToDelete: function (item) {
      this.actionToDelete = item;
      this.$refs["action-confirm-modal"].show();
    },
    removeImprovementAction: function () {
      if (this.actionToDelete.id) {
        axios
          .delete(
            `${process.env.VUE_APP_API_HOST}/api/admin/improvement-actions/${this.actionToDelete.id}`
          )
          .then(() => {
            this.data.improvement_actions =
              this.data.improvement_actions.filter(
                (el) => el.id != this.actionToDelete.id
              );
            this.actionToDelete = null;
          })
          .catch(() => {});
      } else {
        this.data.improvement_actions.pop();
        this.actionToDelete = null;
      }
    },
  },
};
</script>

<style lang="scss">
.risks {
  padding-top: 3vh;
  padding-left: 2vw;
  padding-right: 2vw;
  .titleMachine {
    font-size: 18px;
    margin-bottom: 4vh;
  }
  b {
    font-size: 18px;
  }
  .images {
    padding-top: 1.5vh;
    display: flex;
    img {
      height: 22vh;
      width: auto;
    }
    img:hover {
      cursor: pointer;
    }
  }
  .risk {
    // margin-top: 25px;
    padding: 0 2vw;
    .description {
      width: 100%;
      height: 18vh;
    }
    .smallBtn {
      font-size: 14px;
      svg {
        margin-right: 5px;
      }
    }
    .imagesRisk {
      .col-padding {
        padding-bottom: 8px;
      }
      .imgDeletable {
        position: relative;
        width: fit-content;
        padding: 0 15px;
        .deleteIcon {
          position: absolute;
          top: 0px;
          right: 0px;
        }
        .deleteIcon:hover {
          cursor: pointer;
        }
        img {
          margin-top: 8px;
          height: 40vh;
          width: 60vh;
        }
      }
    }
    .result {
      background: #e9ecef;
      padding: 10px;
      border-radius: 12px;
    }
    .titleAPR {
      font-weight: bold;
      margin-top: 12px;
    }
    .aprForm {
      margin-top: 15px;
      label {
        font-size: 14px;
      }
      .smallInput {
        width: 80%;
        text-align: center;
      }
    }
    .iconContainer {
      display: flex;
      justify-content: flex-end;
      .icon {
        margin-left: 10px;
        height: 100%;
        width: 40px;
        border: 1px solid gray;
        border-radius: 7px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .icon:hover {
        cursor: pointer;
        background-color: #d0d2d8;
        color: white;
        border: 1px solid #d0d2d8;
      }
    }
    .improvementActionsContent {
      border: #eeeeee solid 1px;
      border-radius: 5px;
      padding: 15px;
    }
  }
}
.saveContent {
  display: flex;
  align-items: center;
  span {
    margin-left: 25px;
  }
}

.description-item {
  background-color: #e9ecef;

  .description-item-text {
    padding: 3px;
    word-break: break-all;
    word-wrap: break-word;
  }

  .checkbox-container {
    display: block;
    position: relative;
    padding: 10px;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    // font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* Hide the browser's default checkbox */
  .checkbox-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #eee;
  }

  /* On mouse-over, add a grey background color */
  .checkbox-container:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the checkbox is checked, add a blue background */
  .checkbox-container input:checked ~ .checkmark {
    background-color: #2196f3;
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .checkbox-container input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .checkbox-container .checkmark:after {
    left: 9px;
    top: 40%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
}

.copy {
  .description-item {
    background-color: #e9ecef;
  }

  .header {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 12px 20px;
    border: 0.5px solid #e9eaee;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    .warning {
      position: absolute;
      right: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      // padding: 5px 8px;
      border: 1px solid transparent;
      border-radius: 8px;
      background-color: #fef2e9;
    }
    .iconAccordion {
      position: absolute;
      right: 20px;
    }
  }
  .header:hover {
    cursor: pointer;
  }
  .body {
    padding: 20px 20px;
    border: 0.5px solid #e9eaee;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    border-top: 0;
    width: 100%;
    display: none;
  }
}
</style>
